import { getUpcomingMeetings } from 'store/chat/services/getUpcomingMeetings.service';
import { reconcileUpcomingMeetings } from '../slices/chatSlice';

// Reminders fire 15 min before a meeting, so a 48-hour look-ahead is plenty and
// keeps the fetch cheap even when open-ended series have materialized dozens of
// future occurrences per thread.
const REMINDER_HORIZON_HOURS = 48;

/**
 * Seed the reminder scheduler with the user's upcoming meetings across the
 * threads it knows, in one call. Merges into the per-thread store, and drops
 * meetings the answer shows are gone from the threads it read (see
 * reconcileUpcomingMeetings) — an API without coverage only merges.
 */
export const fetchUpcomingMeetings = (threadIds) => async (dispatch) => {
  const ids = (threadIds || []).filter(Boolean);
  if (ids.length === 0) return;
  try {
    const response = await getUpcomingMeetings(ids, {
      withinHours: REMINDER_HORIZON_HOURS,
    });
    const answer = Array.isArray(response)
      ? { meetings: response, coverage: null }
      : response;
    if (!Array.isArray(answer?.meetings)) return;
    dispatch(reconcileUpcomingMeetings(answer));
  } catch {
    // Reminders are best-effort; a failed fetch just means none this cycle.
  }
};
